<template>
  <modal
    class="addNewRetainershipModal"
    name="updateGPMModal"
    transition="pop-out"
    :width="modalWidth"
    :height="500"
    @closed="closed"
    @opened="opened"
  >
    <div class="retainership__box">
      <button
        type="button"
        class="close modal-close"
        aria-label="Close"
        @click="closed"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="text-center">
        <h3 class="mt-2 add__retainership__header">
          <span>
            <img src="@/assets/img/deal.png" width="50px" />
          </span>
          <span v-if="!this.$route.query.companyID">{{
            $t("text.gManagement.updateCompanyGroup")
          }}</span>
          <span v-else>{{ $t("text.gManagement.updateIndustryGroup") }}</span>
        </h3>

        <div class="sign_up_form_section">
          <form>
            <div class="mt-3 form_input_section">
              <div class="input__block" ref="phone_input_div">
                <input
                  type="text"
                  :placeholder="$t('text.detailAction.name')"
                  class="form-control w-100"
                  v-model="grpMgt.name"
                />
              </div>
            </div>
            <div class="mt-3 form_input_section">
              <div class="input__block" ref="phone_input_div">
                <input
                  type="text"
                  :placeholder="$t('text.detailAction.description')"
                  class="form-control w-100"
                  v-model="grpMgt.description"
                />
              </div>
            </div>
            <div class="mt-3 form_input_section">
              <div class="input__block" ref="phone_input_div">
                <input
                  type="email"
                  :placeholder="$t('text.detailAction.email')"
                  class="form-control w-100"
                  v-model="grpMgt.email"
                />
              </div>
            </div>

            <div
              class="mt-3 form_input_section"
              v-if="!this.$route.query.companyID"
            >
              <div class="mt-3 input__block">
                <select v-model="grpMgt.category">
                  <option value="null" selected disabled>
                    {{ $t("text.gManagement.selectCategory") }}
                  </option>
                  <option
                    :value="category.name"
                    v-for="(category, index) in categoryList"
                    :key="index"
                  >
                    <span>
                      {{ category.name }}
                    </span>
                  </option>
                </select>
              </div>
            </div>

            <div class="mt-5 text-center">
              <button
                class="btn dealers_btn"
                @click="updateGPM"
                :disabled="isButtonDisabled ? true : null"
                :style="[
                  isButtonDisabled
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' },
                ]"
              >
                {{ $t("text.detailAction.update") }}
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="19px"
                  class="ml-3 loader"
                />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
const MODAL_WIDTH = 700;
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "updateGPMModal",
  props: ["grpMgt", "companyId"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      showLoader: false,
      categoryList: [],
    };
  },
  // watch: {
  //   companyId(oldValue, newValue) {
  //     this.getCompanyBranchDealers();
  //   },
  // },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    opened() {
      if (!this.$route.query.companyID) {
        this.getCategories();
      }
    },
    closed() {
      this.$modal.hide("updateGPMModal");
      // this.grpMgt = {};
    },
    getCategories() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Role/GroupCategories/EPUMP`,
          configObject.authConfig()
        )
        .then((response) => {
          const namesToFilter = ["Team", "Sales Rep", "Regional Engineer"];

          const filteredItems = response.data.filter((item) =>
            namesToFilter.includes(item.name)
          );

          this.categoryList = filteredItems;
        })
        .catch((error) => {
          // this.showLoader = false;
        });
    },
    updateGPM(event) {
      event.preventDefault();
      if (!this.grpMgt.name) {
        this.$toast.open({
          message: this.$t("text.gManagement.inputName"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.grpMgt.description) {
        this.$toast.open({
          message: this.$t("text.gManagement.inputDesc"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.grpMgt.email) {
        this.$toast.open({
          message: this.$t("text.gManagement.inputEmail"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      // if (!this.$route.query.companyID && !this.grpMgt.category) {
      //   this.$toast.open({
      //     message: this.$t("text.gManagement.chooseCategory"),
      //     type: "success",
      //     duration: 3000,
      //   });
      //   return;
      // }

      const data = {
        name: this.grpMgt.name,
        description: this.grpMgt.description,
        id: this.grpMgt.id,
        email: this.grpMgt.email,
        category: this.$route.query.companyID ? "Group" : this.grpMgt.category,
        companyId: this.companyId,
      };
      $(".loader").show();
      this.isButtonDisabled = true;

      this.axios
        .put(
          `${configObject.apiBaseUrl}/GroupManagement/EditGroup`,
          data,
          configObject.authConfig()
        )
        .then((res) => {
          this.$toast.open({
            message: this.$t("text.gManagement.updatedGroup"),
            type: "success",
            duration: 3000,
          });

          $(".loader").hide();
          this.isButtonDisabled = false;
          this.grpMgt = "";
          this.$modal.hide("updateGPMModal");
          this.$eventHub.$emit("getGPM");
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
          });
        });
    },
  },
};
</script>
